// Remove our preload class from the body, preventing early CSS transitions
import '@utils/preload';

// CSS needs to be imported here as it's treated as a module
import '@/scss/style.scss';

// ================================================
// All third-party, globally-required libraries should be loaded here
// ================================================

// Support for lazyload images (and bg images)
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// Flickity - please use `data-flickity` options to configure
import 'flickity';
import 'flickity-bg-lazyload';

// An excellent, responsive and lightweight lightbox
import 'spotlight.js';

// Update the CSRF field on Formie forms
import formieCsrf from './components/formie-csrf';

// ================================================
// SUI Components
// ================================================

// Maps
import GoogleMapEmbed from '@components/GoogleMapEmbed.vue';

// Calendar
import FullCalendar from '@components/FullCalendar.vue';

import ProfileSwatch from '@components/ProfileSwatch.vue';

// Lazy header

// ================================================
// Setup Vue3 - Use only if this project needs Vue!
// ================================================
import { createApp } from 'vue';

// Import all globally-available components here. Be responsible please.
import {
    Dialog,
    DialogDescription,
    DialogOverlay,
    DialogTitle,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue';
import LazyHeader from '../vue/components/LazyHeader.vue';

const app = createApp({
    delimiters: ['${', '}'],

    components: {
        TransitionRoot,
        TransitionChild,
        HuiDialog: Dialog,
        HuiDialogOverlay: DialogOverlay,
        HuiDialogTitle: DialogTitle,
        HuiDialogDescription: DialogDescription,
        HuiDisclosure: Disclosure,
        HuiDisclosureButton: DisclosureButton,
        HuiDisclosurePanel: DisclosurePanel,
        HuiPopover: Popover,
        HuiPopoverButton: PopoverButton,
        HuiPopoverPanel: PopoverPanel,
        HuiTabGroup: TabGroup,
        HuiTabList: TabList,
        HuiTab: Tab,
        HuiTabPanels: TabPanels,
        HuiTabPanel: TabPanel,
        GoogleMapEmbed,
        FullCalendar,
        LazyHeader,
        ProfileSwatch,
    },

    data() {
        return {
            navActive: false,
            stickyNav: false,
            showHeader: true,
            stickyHeader: false,
            openProfileModals: [],
        };
    },

    mounted() {
        // Because we're using Vue, anything that interacts with the DOM should go here.

        formieCsrf();

        // Header link drop down
        const topDD = document.querySelectorAll('.js-show-dd');

        if (topDD.length) {
            topDD.forEach((e) => {
                const jsDD = e.querySelector('.js-dd');
                e.addEventListener('click', (e) => {
                    jsDD.classList.toggle('hidden');
                });
            });
        }

        // Header link drop down
        const headerDD = document.querySelectorAll('.menu-item.has-children');
        const headerBar = document.querySelector('.header-bar');

        if (headerDD.length) {
            headerDD.forEach((e) => {
                e.addEventListener('mouseenter', (event) => {
                    e.classList.add('menu-item-active');
                    headerBar.classList.add('header-active');
                });
                e.addEventListener('mouseleave', (event) => {
                    e.classList.remove('menu-item-active');
                    headerBar.classList.remove('header-active');
                });
            });
        }

        // Virtual tour links
        const pin = document.querySelectorAll('.js-pin');
        const pinCards = document.querySelectorAll('.js-pin-card');

        if (pin.length) {
            pin.forEach((e) => {
                e.addEventListener('click', (event) => {
                    const pinId = e.dataset.pinid;
                    pinCards.forEach((element) => {
                        element.classList.add('hidden');
                    });

                    document
                        .querySelector(`[data-pincardid="${pinId}"]`)
                        .classList.toggle('hidden');
                });
            });
        }

        // Site wide careers

        const careersDD = document.querySelector('.js-careers-select');
        const jobs = document.querySelectorAll('.js-job');

        const updateJobFunction = function() {
            const school = careersDD.value.substring(
                careersDD.value.lastIndexOf('#') + 1,
            );

            if (jobs) {
                jobs.forEach((job) => {
                    if (school == 'all') {
                        job.classList.remove('hidden');
                    } else {
                        job.classList.add('hidden');
                    }
                });
            }

            const selectedSchool = document.querySelectorAll(
                `[data-job="${school}"]`,
            );
            if (selectedSchool) {
                selectedSchool.forEach((school) => {
                    school.classList.remove('hidden');
                });
            }
        };

        if (careersDD) {
            updateJobFunction();
            careersDD.addEventListener('change', (event) => {
                updateJobFunction();
            });
        }

        // Multiple Calendar JS
        const calendarDD = document.querySelector('.js-calendar-select');
        const allCalendars = document.querySelectorAll('.js-calendar');

        if (calendarDD) {
            calendarDD.addEventListener('change', (event) => {
                const calendarId = event.target.value;

                allCalendars.forEach((cal) => {
                    cal.classList.remove('show-cal');
                });

                document
                    .querySelector(`.${calendarId}`)
                    .classList.add('show-cal');
            });
        }

        function scrollTo(hash) {
            location.hash = `#${hash}`;
        }
    },
    methods: {
        isProfileModalOpen(id) {
            return this.openProfileModals[id] ? true : false;
        },

        setProfileModal(id, value) {
            this.openProfileModals[id] = value;
        },
    },
});
app.mount('#app');
